import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export default function SiteHeader({ variant = 'default' }) {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const publicLinks = [
    { to: '/pricing', label: t('common.pricing', 'Pricing') },
    { to: '/blog',    label: t('common.blog', 'Blog') },
    { to: '/about',   label: t('common.about', 'About') },
  ];
  const authedLinks = [
    { to: '/dashboard', label: t('common.dashboard', 'Dashboard') },
    { to: '/pricing',   label: t('common.pricing', 'Pricing') },
    { to: '/about',     label: t('common.about', 'About') },
  ];
  const links = user ? authedLinks : publicLinks;

  return (
    <nav className="relative z-40 border-b border-champagne/10 bg-midnight/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-aura-purple to-aura-gold flex items-center justify-center shrink-0">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl sm:text-2xl font-serif font-medium text-text-light truncate">Memouraa</span>
        </Link>

        <div className="hidden md:flex items-center gap-4">
          {links.map(l => (
            <Link key={l.to} to={l.to} className="text-text-muted hover:text-champagne transition-colors text-sm">
              {l.label}
            </Link>
          ))}
          {user ? (
            <button onClick={logout} className="text-text-muted hover:text-champagne transition-colors text-sm">
              Logout
            </button>
          ) : (
            <>
              <Link to="/login" className="text-text-muted hover:text-champagne transition-colors text-sm">{t('common.signIn','Sign in')}</Link>
              <Link to="/register" className="bg-champagne text-midnight px-4 py-2 rounded-lg text-sm font-medium hover:bg-champagne-light">
                {t('common.getStarted','Get started')}
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden p-2.5 rounded-lg hover:bg-white/5 text-text-light min-w-[44px] min-h-[44px] flex items-center justify-center"
          onClick={() => setOpen(o => !o)}
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-champagne/10 bg-midnight">
          <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
            {links.map(l => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                    className="px-3 py-3 rounded-lg text-text-light hover:bg-white/5">
                {l.label}
              </Link>
            ))}
            {user ? (
              <button onClick={() => { setOpen(false); logout(); }}
                      className="text-left px-3 py-3 rounded-lg text-text-light hover:bg-white/5">
                Logout
              </button>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}
                      className="px-3 py-3 rounded-lg text-text-light hover:bg-white/5">Sign in</Link>
                <Link to="/register" onClick={() => setOpen(false)}
                      className="px-3 py-3 rounded-lg bg-champagne text-midnight text-center font-medium">
                  Get started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
